import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY } from "@/data/site";

export const WhyUs = () => {
  return (
    <section id="perche" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <h4 className="text-xs uppercase tracking-[0.3em] text-gold-500 font-sans mb-5">
            Perché sceglierci
          </h4>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-white leading-tight">
            Un percorso completo.
            <br />
            <span className="text-gray-400 italic">Dal primo accordo al palcoscenico.</span>
          </h2>
          <p className="mt-6 text-base text-gray-400 max-w-2xl">
            Non la solita scuola di musica del paese, ma un centro di formazione
            artistica strutturato, accreditato da due Regioni e convenzionato con
            Trinity College London.
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Star;
            return (
              <motion.div
                key={w.title}
                data-testid={`why-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group rounded-2xl border border-white/10 bg-ink-800 p-7 hover:border-gold-500/50 transition-colors duration-300"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold-500/10 border border-gold-500/20 text-gold-500 group-hover:bg-gold-500 group-hover:text-ink-900 transition-colors duration-300">
                  <Icon size={22} />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-white">{w.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-400">{w.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
